module.exports = __webpack_public_path__ + "img/IMG_9321_L_Foamcore.ee7685c2.jpg";